import React from 'react';
import { Outlet, Navigate, useLocation, Link, useNavigate } from 'react-router-dom';
import '../styles/Dashboard.css';
import SideMenu from '../components/SideMenu'; // SideMenu 컴포넌트 불러오기

const BASE_URL = process.env.REACT_APP_BASE_URL;

const Dashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // 대시보드 경로에 정확히 있을 때만 근로자 정보 관리로 리다이렉트
  if (location.pathname === '/dashboard') {
    return <Navigate to="/dashboard/worker-management" replace />;
  }

  // 로그아웃 함수
  const handleLogout = async () => {
    try {
      // 1. 서버 측 로그아웃 요청 (토큰 무효화)
      const token = localStorage.getItem('token');
      if (token) {
        try {
          // 서버에 로그아웃 요청 (토큰 무효화)
          await fetch(`${BASE_URL}/api/auth/logout`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });
        } catch (error) {
          console.error('서버 로그아웃 처리 오류:', error);
          // 서버 로그아웃 실패해도 클라이언트 측 로그아웃은 계속 진행
        }
      }

      // 2. 브라우저 저장소 데이터 정리
      // localStorage에서 모든 관련 정보 삭제
      localStorage.removeItem('token');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('userInfo');
      localStorage.removeItem('userType');
      localStorage.removeItem('companyCode');
      localStorage.removeItem('middleCompanyCode');
      
      // sessionStorage에서도 관련 정보 삭제
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('userInfo');
      sessionStorage.removeItem('processedPayments');
      
      // 3. 앱 상태 초기화 (필요한 경우 추가)
      
      // 4. 로그인 페이지로 리디렉션
      navigate('/login');
      
      console.log('로그아웃 성공');
    } catch (error) {
      console.error('로그아웃 처리 중 오류:', error);
      // 오류가 발생해도 로그인 페이지로 이동
      navigate('/login');
    }
  };

  return (
    <div className="dashboardContainer">
      {/* 상단 앱바 */}
      <div className="dashboardHeader">
        <div className="headerLeft">
          <Link to="/dashboard/worker-management" className="logoLink">
          <h2 className="logoText">TAPGO</h2>
          </Link>
        </div>
        <div className="headerRight">
          <button className="logoutButton" onClick={handleLogout}>
            로그아웃
          </button>
        </div>
      </div>

      <div className="contentWrapper">
        {/* 사이드 메뉴 */}
        <SideMenu />

        {/* 메인 컨텐츠 - Outlet을 통해 자식 라우트의 컴포넌트를 표시 */}
        <div className="mainContent">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 